import { useAppSelector } from 'shared/hooks'

import { api } from '../api'
import { selectors } from '../utils/selectors'
import { useCurrentId } from './useCurrentId'

export function useConversationalist() {
	const id = useCurrentId()
	api.useParticipantsQuery(id, {
		skip: !id
	})

	return useAppSelector(state => selectors.conversationalist(state, id))
}
